import React, {useEffect, useState} from 'react';
import {selectDefaultSetting} from "../../../../../store/reducers/settings/settingsReducer";
import {useSelector} from "react-redux";
import {Translate} from "../../../../../lang/lang";
import {selectLang} from "../../../../../store/reducers/main/main";
import {useNavigate} from "react-router-dom";
import {selectCurrency} from "../../../../../store/reducers/currency/currencyReducer";
import {selectWarehouses} from "../../../../../store/reducers/warehouse/warehouseReducer";
import {
    getPurchaseItemAsync,
    purchaseAddItemAsync, purchaseChangeEmployeeAsync, purchaseRegisterAsync, purchaseUpdateNoteAsync,
    selectPurchaseDefaultsSettings
} from "../../../../../store/reducers/warehouse/purchaseReducer";
import {FormProvider, useForm} from "react-hook-form";
import dayjs from "dayjs";
import {UZS} from "../../../../../enum/item/itemWrapper";
import toast from "react-hot-toast";
import EventBus from "../../../../../eventbus/EventBus";
import {
    WAREHOUSE_OPERATION_PURCHASE_ADD_CLIENT_SUCCESS,
    WAREHOUSE_OPERATION_PURCHASE_ADD_ITEM_SUCCESS,
    WAREHOUSE_OPERATION_PURCHASE_APPROVED_ITEM_SUCCESS,
    WAREHOUSE_OPERATION_PURCHASE_DATE_SUCCESS,
    WAREHOUSE_OPERATION_PURCHASE_DELETE_ITEM_SUCCESS, WAREHOUSE_OPERATION_PURCHASE_NUMBER_SUCCESS,
    WAREHOUSE_OPERATION_PURCHASE_UPDATE_ITEM_SUCCESS
} from "../../../../../eventbus/warehouse/purchaseEvent";
import {Form} from "react-bootstrap";
import PurchaseForm from "./PurchaseForm";

const AddPurchaseForm = () => {
    const purchaseDefaultsSettings = useSelector(selectPurchaseDefaultsSettings)
    const [response, setResponse] = useState(null)
    const [purchase, setPurchase] = useState(null)
    const [loading, setLoading] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const warehouses = useSelector(selectWarehouses)
    const currencies = useSelector(selectCurrency)
    const navigate = useNavigate()
    const lang = useSelector(selectLang)
    const t = Translate;
    const settings = useSelector(selectDefaultSetting)

    const form = useForm({
        defaultValues: {
            contractor_id: null,
            employee_id: purchaseDefaultsSettings?.defaultEmployeeId || null,
            cashbox_id: settings?.cash_box?.default_id || null,
            date: dayjs(new Date(), "YYYY-MM-DD HH:mm").toDate(),
            note: '',
            number: null,
            item_id: null,
            warehouse_id: settings?.warehouse?.default_id || null,
            quantity: null,
            marks: [],
            commonPrice: {
                amount: '0',
                currency_id: currencies?.find(c => c?.code === UZS)?.id,
            },
        }
    })

    const resetForm = (formData) => {
        form.reset({
            contractor_id: formData?.contractor?.id || formData?.contractor_id,
            employee_id: formData?.employee?.id || formData?.employee_id,
            cashbox_id: settings?.cash_box?.default_id || formData?.cashbox?.id || formData?.cashbox_id,
            date: formData?.date && dayjs(formData?.date, "YYYY-MM-DD HH:mm").toDate(),
            note: formData?.note,
            number: formData?.number,
            item_id: null,
            quantity: null,
            warehouse_id: settings?.warehouse?.default_id || null,
            warehouse: warehouses,
            package_measurements: null,
            marks: [],
            commonPrice: {
                amount: '0',
                currency_id: currencies?.find(c => c?.code === UZS)?.id,
            },
        })
    }

    const onSubmit = async (formData, event) => {
        const buttonType = event?.nativeEvent?.submitter?.name
        const quantity = +formData?.quantity * +formData?.package_measurements?.quantity

        const item = {
            item_id: formData?.item_id,
            warehouse_id: formData?.warehouse_id,
            quantity: quantity,
            marks: formData?.marks || [],
            price: {
                amount: +formData?.commonPrice?.amount,
                currency_id: formData?.commonPrice?.currency_id,
            },
        }

        if ((buttonType === "addOrEditPurchase" || buttonType === "addOrEditPurchaseMore") || (event === "addOrEditPurchase" || event === "addOrEditPurchaseMore")) {
            if (buttonType === "addOrEditPurchase" || event === "addOrEditPurchase") {
                setLoading(true)
            } else {
                setLoadingMore(true)
            }
            if (!purchase) {
                await purchaseRegisterAsync({
                    contractor_id: formData?.contractor_id,
                    date: dayjs(formData?.date).format("YYYY-MM-DD HH:mm:ss"),
                    note: formData?.note,
                    number: formData?.number?.trim() ? formData?.number : null,
                    items: [item],
                    employee_id: formData?.employee_id,
                    cashbox_id: formData?.cashbox_id
                })
                    .then(({data}) => {
                        setResponse(data)
                        resetForm(data)
                        toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                    })
                    .catch((error) => {
                        if (error?.response?.data?.includes("warehouse")) {
                            toast.error(t(lang, "Склад не выбран"))
                        } else {
                            toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        setLoadingMore(false)
                    })
            }
            /*if (purchase && response?.contractor?.id !== formData?.contractor_id) {
                await purchaseChangeContractorAsync({purchaseId: purchase.id, contractorId: formData?.contractor_id})
                    .then(({data}) => {
                        setResponse(data)
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        setLoading(false)
                    })
            }*/
            if (purchase) {
                await purchaseAddItemAsync({
                    purchaseId: purchase?.id,
                    operation: item
                })
                    .then(({data}) => {
                        updateNote(formData)
                        // updateNumber(formData)
                        resetForm(formData)
                        updateEmployee(formData)
                        toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                    })
                    .catch((error) => {
                        if (error?.response?.data?.error?.includes("warehouse") || error?.response?.data?.includes("warehouse")) {
                            toast.error(t(lang, "Склад не выбран"))
                        } else {
                            toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                        }
                    })
                    .finally(() => {
                        setLoading(false)
                        setLoadingMore(false)
                    })
            }
        }
    }

    const updateEmployee = (formData) => {
        if (formData?.employee_id || purchase?.employee) {
            if (formData?.employee_id !== purchase?.employee?.id) {
                purchaseChangeEmployeeAsync({purchaseId: purchase?.id, employeeId: formData?.employee_id})
                    .then(({data}) => {
                        setPurchase(data, data.items.reverse())
                    })
                    .catch(() => {})
            }
        }
    }

    const updateNote = (formData) => {
        if (formData?.note !== purchase?.note) {
            purchaseUpdateNoteAsync({purchaseId: purchase?.id, note: formData?.note})
                .then(({data}) => {
                    setPurchase(data, data.items.reverse())
                })
                .catch(() => {})
        }
    }

    useEffect(() => {
        const onAddClientHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_ADD_CLIENT_SUCCESS, (id) => {
            loadPurchase(id)
        })

        const onAddItemHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_ADD_ITEM_SUCCESS, (id) => {
            loadPurchase(id)
        })

        const onUpdateItemHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_UPDATE_ITEM_SUCCESS, (id) => {
            loadPurchase(id)
        })

        const onDeleteItemHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_DELETE_ITEM_SUCCESS, (id) => {
            loadPurchase(id)
        })

        const onApprovedHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_APPROVED_ITEM_SUCCESS, (id) => {
            navigate(`/operation/purchases/view/${id}`)
        })

        const onChangedDateHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_DATE_SUCCESS, (id) => {
            loadPurchase(id)
        })

        const onChangedNumberHandler = EventBus.on(WAREHOUSE_OPERATION_PURCHASE_NUMBER_SUCCESS, (id) => {
            loadPurchase(id)
        })

        return () => {
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_ADD_CLIENT_SUCCESS, onAddClientHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_ADD_ITEM_SUCCESS, onAddItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_UPDATE_ITEM_SUCCESS, onUpdateItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_DELETE_ITEM_SUCCESS, onDeleteItemHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_APPROVED_ITEM_SUCCESS, onApprovedHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_DATE_SUCCESS, onChangedDateHandler)
            EventBus.remove(WAREHOUSE_OPERATION_PURCHASE_NUMBER_SUCCESS, onChangedNumberHandler)
        }
    }, [])

    const loadPurchase = async (id) => {
        await getPurchaseItemAsync({purchaseId: id})
            .then((response) => {
                setPurchase(response.data, response.data.items.reverse())
            })
            .catch((error) => {
                setPurchase(null)
            })
    }

    return (
        <FormProvider {...form}>
            <Form onSubmit={form.handleSubmit(onSubmit)}>
                <PurchaseForm purchase={purchase} loading={loading} addItem={form.handleSubmit(onSubmit)} isEditing={false}/>
            </Form>
        </FormProvider>
    );
};

export default AddPurchaseForm;
